import { useNavigate } from 'react-router-dom';
import {
    FaUsers,
    FaFileInvoice,
    FaExchangeAlt,
    FaFileAlt,
    FaBarcode,
    FaSignOutAlt,
    FaArrowRight,
    FaCog,
    FaMoneyCheckAlt,
    FaFileSignature,
    FaFileContract,
    FaHandHoldingUsd
} from 'react-icons/fa';

const HomeScreen = () => {
    const navigate = useNavigate();

    const goToSection = (path) => navigate(path);

    const handleSair = () => {
        localStorage.setItem('userToken', '');
        localStorage.setItem('userName', '');
        localStorage.setItem('userId', '');
        localStorage.setItem('userIdEmitente', '');
        localStorage.setItem('userCnpjEmitente', '');
        navigate('/');
    };

    const cards = [
        {
            title: 'Controle de Clientes',
            desc: 'Cadastre, edite e gerencie sua base de clientes.',
            icon: <FaUsers />,
            action: () => goToSection('/clientes'),
            color: '#3b82f6'
        },
        {
            title: 'Controle de NFS-e',
            desc: 'Emissão, cancelamentos e relatórios de NFS-e.',
            icon: <FaFileInvoice />,
            action: () => goToSection('/nfs-e'),
            color: '#8b5cf6'
        },
        {
            title: 'Gestão de Cobranças',
            desc: 'Cadastre devedores e gerencie suas dívidas e processos.',
            icon: <FaHandHoldingUsd />, // Novo ícone mais relevante (você pode usar o FaExchangeAlt se preferir)
            action: () => goToSection('/devedores'), // Rota a ser criada
            color: '#06b6d4'
        },
        {
            title: 'Gestão de Processos Judiciais (Acordos e Parcelamentos)',
            desc: 'Criação do Processo, Lançamento das Parcelas, Ciclo de Pagamento.',
            icon: <FaExchangeAlt />,
            action: () => goToSection('/processos'),
            color: '#06b6d4'
        },
        {
            title: 'Documentos e DARFs',
            desc: 'Visualize e baixe seus documentos oficiais.',
            icon: <FaFileAlt />,
            action: () => goToSection('/documentos'),
            color: '#10b981'
        },
        {
            title: 'Gestão de Boletos',
            desc: 'Emissão, baixa e downloads de boletos.',
            icon: <FaBarcode />,
            action: () => goToSection('/financeiro'),
            color: '#f59e0b'
        },
        {
            title: 'Logs de Envio',
            desc: 'Acompanhe o histórico de e-mails e WhatsApps enviados.',
            icon: <FaFileAlt />, // Você pode escolher um ícone diferente
            action: () => goToSection('/logs'), // Nova rota para a tela de logs
            color: '#0ea5e9' // Cor azul
        },
        {
            title: 'Operações Bancárias',
            desc: 'Gerenciamento de extratos bancários.',
            icon: <FaMoneyCheckAlt />,
            action: () => goToSection('/contacorrente'),
            color: '#11022e'
        },
        // {
        //     title: 'Consulta de CNDs',
        //     desc: 'Gerencie as certidões dos seus clientes.',
        //     icon: <FaFileSignature />,
        //     action: () => goToSection('/emConstrucao'),
        //     color: '#11022e'
        // },
        // {
        //     title: 'Parcelamentos',
        //     desc: 'Gerencie os parcelamentos dos seus clientes.',
        //     icon: <FaFileContract />,
        //     action: () => goToSection('/emConstrucao'),
        //     color: '#11022e'
        // },
        {
            title: 'Configurações (Admin)',
            desc: 'Parametros para geração de boletos de notas fiscais',
            icon: <FaCog />,
            action: () => goToSection('/configuration'),
            color: '#11022e'
        }
    ];

    const nomeProjeto = process.env.REACT_APP_NOME_PROJETO;

    return (
        <div style={ui.page}>
            {/* Header com gradiente */}
            <header style={ui.headerBar}>
                <div style={ui.headerLeft}>
                    <h1 style={ui.title}>{nomeProjeto}</h1>
                    <p style={ui.subtitle}>Tudo o que você precisa em um só lugar.</p>
                </div>
                <button onClick={handleSair} style={ui.logoffButton}>
                    <FaSignOutAlt style={{ marginRight: 8 }} />
                    Logoff
                </button>
            </header>

            {/* Grid de cards */}
            <section style={ui.cardsWrap} aria-label="Atalhos principais">
                {cards.map((c, idx) => (
                    <button
                        key={idx}
                        onClick={c.action}
                        style={ui.card}
                        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && c.action()}
                        aria-label={c.title}
                    >
                        <div style={{ ...ui.iconWrap, color: c.color, boxShadow: `0 6px 16px ${c.color}22` }}>
                            {c.icon}
                        </div>
                        <div style={ui.cardBody}>
                            <h2 style={ui.cardTitle}>{c.title}</h2>
                            <p style={ui.cardDesc}>{c.desc}</p>
                        </div>
                        <div style={ui.cardCta}>
                            <FaArrowRight />
                        </div>
                    </button>
                ))}
            </section>
        </div>
    );
};

/** 🎨 UI tokens alinhados com suas telas anteriores */
const ui = {
    page: {
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
        padding: 24,
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
        color: '#111827',

        minHeight: '95vh',
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        boxSizing: 'border-box',
        marginBottom: 40

    },
    // Header
    headerBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 24,
        marginBottom: 24,
        borderRadius: 16,
        border: '1px solid #e5e7eb',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: '#fff',
        boxShadow: '0 20px 40px rgba(0,0,0,0.15)'
    },
    headerLeft: { display: 'flex', flexDirection: 'column' },
    title: { margin: 0, fontSize: '1.75rem', fontWeight: 700, letterSpacing: 0.2 },
    subtitle: { margin: '6px 0 0 0', opacity: 0.9 },

    logoffButton: {
        backgroundColor: 'rgba(255,255,255,0.15)',
        color: '#fff',
        border: '2px solid rgba(255,255,255,0.25)',
        padding: '10px 16px',
        borderRadius: 12,
        fontWeight: 700,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        transition: 'transform .15s ease'
    },

    // Cards
    cardsWrap: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: 20,
        maxWidth: 1000,
        margin: '0 auto'
    },
    card: {
        backgroundColor: '#fff',
        borderRadius: 14,
        border: '1px solid #e5e7eb',
        boxShadow: '0 6px 16px rgba(0,0,0,0.06)',
        padding: 18,
        display: 'grid',
        gridTemplateColumns: '56px 1fr 28px',
        alignItems: 'center',
        gap: 16,
        textAlign: 'left',
        cursor: 'pointer',
        transition: 'transform .16s ease, box-shadow .16s ease, border-color .16s ease',
        outline: 'none'
    },
    iconWrap: {
        width: 56,
        height: 56,
        borderRadius: 14,
        backgroundColor: '#f9fafb',
        display: 'grid',
        placeItems: 'center',
        fontSize: 24
    },
    cardBody: {},
    cardTitle: { margin: 0, fontSize: '1.05rem', fontWeight: 700, color: '#111827' },
    cardDesc: { margin: '6px 0 0 0', color: '#6b7280', fontSize: '.9rem', lineHeight: 1.4 },
    cardCta: { display: 'grid', placeItems: 'center', color: '#9ca3af' }
};

// Pequenos “efeitos” de interação (opcional, mas funciona com inline styles)
const addHover = (() => {
    const card = ui.card;
    ui.card = {
        ...card,
        ':hover': undefined // placeholder
    };
    // simulando :hover/:focus via JS – se você usa CSS-in-JS, troque por :hover nativo
    if (typeof window !== 'undefined') {
        // nada a fazer aqui; mantemos apenas os estilos base
    }
    // para melhorar o feedback sem CSS-in-JS, faça leves ajustes de base:
    ui.card = {
        ...ui.card,
        boxShadow: '0 6px 16px rgba(0,0,0,0.06)'
    };
    ui.logoffButton = {
        ...ui.logoffButton,
        ':active': undefined
    };
    return true;
})();

export default HomeScreen;
